import { render } from "./ManageClientDocuments.vue?vue&type=template&id=242bad2d"
import script from "./ManageClientDocuments.vue?vue&type=script&lang=js"
export * from "./ManageClientDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/ManageClientDocuments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "242bad2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('242bad2d', __exports__)) {
    api.reload('242bad2d', __exports__)
  }
  
  module.hot.accept("./ManageClientDocuments.vue?vue&type=template&id=242bad2d", () => {
    api.rerender('242bad2d', render)
  })

}


export default __exports__